module.exports = __webpack_public_path__ + "img/pop_wallet_logo_solong@2x.645a6254.png";